import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { class: "w-11/12 mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5" }
const _hoisted_5 = { class: "mt-1 ml-7 flex items-end justify-between" }
const _hoisted_6 = { class: "text-lg text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "+ 255", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "text-lg" }
const _hoisted_10 = { class: "mt-1 ml-7 flex items-end justify-between" }
const _hoisted_11 = { class: "text-lg text-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "+ 255", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "text-lg" }
const _hoisted_15 = { class: "mt-1 ml-7 flex items-end justify-between" }
const _hoisted_16 = { class: "text-lg text-white" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "+ 255", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "text-lg" }
const _hoisted_20 = { class: "mt-1 ml-7 flex items-end justify-between" }
const _hoisted_21 = { class: "text-lg text-white" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "+ 255", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "text-lg" }

import { computed, onMounted, ref } from 'vue'
import SidebarView from './partials/SidebarView.vue'
import HeaderView from './partials/HeaderView.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const isActive = ref(false)
    const showTypeRole = ref(0)

    onMounted(() => {
        const item = localStorage.getItem('type');
        showTypeRole.value = Number(item)
    })

    const roleClass = computed(() => {
      if (showTypeRole.value === 3) {
        return 'asideBarSuperAdmin';
      } else if (showTypeRole.value === 2) {
        return 'asideBarAdmin';
      } else if (showTypeRole.value === 1) {
        return 'asideBarDriver';
      }  else if (showTypeRole.value === 4) {
        return 'asideBarSuperSuperAdmin';
      } 
      else {
        return '';
      }
    });
    function checkStatus() {
        fetch("http://31.220.89.29:5000/api/Status", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            mode: "cors" // Assurez-vous d'utiliser 'cors'
        })
        .then(response => {
            if (!response.ok) {
                throw new Error("Network response was not ok " + response.statusText);
            }
            return response.json();
        })
        .then(data => {
            console.log("Success:", data);
        })
        .catch(error => {
            console.error("Error:", error);
        });
    }
    onMounted(() => {
        checkStatus()
  })

// Call the function to check the status


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarView),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderView),
      _createElementVNode("main", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass([roleClass.value, "rounded-lg cursor-pointer border border-stroke text-white px-7.5 py-6 shadow-default dark:border-strokedark dark:bg-boxdark"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Users')), 1),
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('AddedThisWeek')), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([roleClass.value, "rounded-lg border cursor-pointer border-stroke text-white px-7.5 py-6 shadow-default dark:border-strokedark dark:bg-boxdark"])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_11, " Truck " + _toDisplayString(_ctx.$t('Statistics')), 1),
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('AddedThisWeek')), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([roleClass.value, "rounded-lg border cursor-pointer border-stroke text-white px-7.5 py-6 shadow-default dark:border-strokedark dark:bg-boxdark"])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('Shipment')), 1),
                    _hoisted_17,
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('AddedThisWeek')), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([roleClass.value, "rounded-lg cursor-pointer border border-stroke text-white px-7.5 py-6 shadow-default dark:border-strokedark dark:bg-boxdark"])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t('Driver')), 1),
                    _hoisted_22,
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('AddedThisWeek')), 1)
                  ])
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})